module.exports = "67372db74f67922b94229fa387614ce0.png";


//////////////////
// WEBPACK FOOTER
// ./assets/sprites/kirigami-whole-shadow.png
// module id = 36
// module chunks = 0